import { trTag } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import OverFlowTooltipWithTabsMui from "../../../common/OverFlowTooltipWithTabsMui";

// Backend joins names with control char \u0001 (not ', ') to avoid clashing with commas
// that may already appear inside a bookmark name.
const BOOKMARK_NAME_SEPARATOR = '\u0001';

function TaggedBookmarkListName({bookmarkListText, className=''}) {
    useTranslationSubscription();

    const displayText = bookmarkListText
        ? bookmarkListText.split(BOOKMARK_NAME_SEPARATOR).map(name => name?.trim()).filter(name => name).map(name => trTag(name)).join(', ')
        : '_';
    return (
        <OverFlowTooltipWithTabsMui
            className={className}
            value={displayText}
        />
    );
}

export default TaggedBookmarkListName;
